import { Grid } from '@mui/material'
import UOMClassesLookupTable from './components/UOMClassesLookupTable'
import { useTranslation } from 'react-i18next'
import AdminMenuTitle from 'components/AdminMenuTitle/AdminMenuTitle'

function UOMClassesLookup() {
    const { t } = useTranslation()
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <AdminMenuTitle title={t('uoms.title.uom_categories')} />
            </Grid>
            <Grid item container>
                <UOMClassesLookupTable />
            </Grid>
        </Grid>
    )
}

export default UOMClassesLookup
